import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

const gainers = [
  { id: 'gainer-001', symbol: 'REALTY', ltp: '₹876.40', change: '+4.28%', vol: '8.2M' },
  { id: 'gainer-002', symbol: 'BAJFINANCE', ltp: '₹7,234.80', change: '+1.58%', vol: '0.9M' },
  { id: 'gainer-003', symbol: 'AXISBANK', ltp: '₹1,187.40', change: '+1.62%', vol: '2.9M' },
  { id: 'gainer-004', symbol: 'MARUTI', ltp: '₹12,456.00', change: '+1.53%', vol: '0.4M' },
  { id: 'gainer-005', symbol: 'INFY', ltp: '₹1,654.90', change: '+1.35%', vol: '2.7M' },
];

const losers = [
  { id: 'loser-001', symbol: 'SUNPHARMA', ltp: '₹1,876.60', change: '-1.28%', vol: '1.4M' },
  { id: 'loser-002', symbol: 'TATASTEEL', ltp: '₹167.85', change: '-1.44%', vol: '18.7M' },
  { id: 'loser-003', symbol: 'HDFCBANK', ltp: '₹1,876.25', change: '-0.46%', vol: '3.8M' },
  { id: 'loser-004', symbol: 'WIPRO', ltp: '₹567.35', change: '-0.56%', vol: '5.1M' },
  { id: 'loser-005', symbol: 'RELIANCE', ltp: '₹2,987.45', change: '-0.41%', vol: '2.3M' },
];

function MoversTable({ data, type }: { data: typeof gainers; type: 'gainer' | 'loser' }) {
  return (
    <div className="card-elevated overflow-hidden">
      <div className={`flex items-center gap-2 px-4 py-3 border-b border-border ${
        type === 'gainer' ? 'bg-positive-subtle' : 'bg-negative-subtle'
      }`}>
        {type === 'gainer' ? <TrendingUp size={14} className="text-positive" /> : <TrendingDown size={14} className="text-negative" />}
        <h3 className={`text-sm font-semibold ${type === 'gainer' ? 'text-positive' : 'text-negative'}`}>
          Top {type === 'gainer' ? 'Gainers' : 'Losers'}
        </h3>
      </div>
      <div className="overflow-x-auto scrollbar-thin">
        <table className="w-full text-xs min-w-[340px]">
          <thead>
            <tr className="border-b border-border">
              <th className="text-left px-3 md:px-4 py-2 text-2xs font-semibold text-muted-foreground uppercase tracking-wide">Symbol</th>
              <th className="text-right px-2 md:px-3 py-2 text-2xs font-semibold text-muted-foreground uppercase tracking-wide">LTP</th>
              <th className="text-right px-2 md:px-3 py-2 text-2xs font-semibold text-muted-foreground uppercase tracking-wide">Change</th>
              <th className="text-right px-2 md:px-3 py-2 text-2xs font-semibold text-muted-foreground uppercase tracking-wide hidden sm:table-cell">Volume</th>
            </tr>
          </thead>
          <tbody>
            {data.map((s) => (
              <tr key={s.id} className="border-b border-border/50 hover:bg-muted/40 active:bg-muted/60 transition-colors cursor-pointer touch-manipulation">
                <td className="px-3 md:px-4 py-3 font-semibold text-foreground">{s.symbol}</td>
                <td className="px-2 md:px-3 py-3 text-right font-tabular text-foreground">{s.ltp}</td>
                <td className={`px-2 md:px-3 py-3 text-right font-tabular font-semibold ${type === 'gainer' ? 'text-positive' : 'text-negative'}`}>
                  {s.change}
                </td>
                <td className="px-2 md:px-3 py-3 text-right text-muted-foreground hidden sm:table-cell">{s.vol}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default function TopMoversTable() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <MoversTable data={gainers} type="gainer" />
      <MoversTable data={losers} type="loser" />
    </div>
  );
}